import moment from 'moment'
import { isArray } from 'lodash'

export const CREATION_BODY = {
  entityId: '-',
  isOpenToSchool: true,
  isOpenToInstitution: true,
  isOpenToStudent: true
}

export const CHAT_ROOM_TYPES = {
  SCHEDULE: 'SCHEDULE'
}

export const hasUnreadMessages = chatRoom => {
  const lastMessageAt = moment(chatRoom.lastMessageAt)

  return (
    isArray(chatRoom.subscriptions) && chatRoom.subscriptions.some(subscription => (
      subscription.lastConsultation === null ||
      moment(subscription.lastConsultation).isBefore(lastMessageAt)
    ))
  )
}

export class ChatRoom {
  constructor ({ id, entityId, isOpenToSchool = true, isOpenToInstitution = true, isOpenToStudent = true, lastMessageAt, type }) {
    this.id = id ?? -1
    this.entityId = entityId ?? null
    this.isOpenToSchool = isOpenToSchool
    this.isOpenToInstitution = isOpenToInstitution
    this.isOpenToStudent = isOpenToStudent
    this.lastMessageAt = lastMessageAt ?? null
    this.type = type ?? null
  }

  toRequestBody () {
    const body = {}

    Object.entries(this).forEach(([key, value]) => {
      if (key !== 'id' && value !== undefined) {
        body[key] = value
      }
    })

    return body
  }
}
